<template>
  <el-container>
    <!-- 标题 -->
    <el-header class="pa-0">
      <div class="bg-color-w ht-62 dy-flex jy-c-sb">
        <div :xs="4" class="pl-30 dy-flex jy-c-sb align-i-c">
          <img src="/img/images/dbsx_icon.png" class="wt-40 ht-40" />
          <div class="pl-10 fs-20">{{ $t("grxx.personalcenter") }}</div>
        </div>
        <!-- 中英文切换 -->
        <Languageqh v-if="$store.state.sysCs.sfqy_zywqh == '1'"></Languageqh>
      </div>
    </el-header>
    <!-- 内容 -->
    <el-main class="pa-0">
      <div class="dy-flex ht-all">
        <!-- 左侧导航 -->
        <div class="bg-color-w wt-206 pt-16">
          <div
            class="menu"
            :class="activeMenu == '1' ? 'acMenu' : ''"
            @click="selectMenu('1')"
          >
            <i class="el-icon-postcard" />
            <span>{{ $t("grxx.basicinformation") }}</span>
          </div>
          <div
            class="menu"
            :class="activeMenu == '2' ? 'acMenu' : ''"
            @click="selectMenu('2')"
            v-if="$store.state.sysCs.sfqyeditpwdlink === '1'"
          >
            <i class="el-icon-lock" />
            <span>{{ $t("grxx.changepassword") }}</span>
          </div>
          <div
            class="menu"
            :class="activeMenu == '3' ? 'acMenu' : ''"
            @click="selectMenu('3')"
            v-if="$store.state.sysCs.sfqy_editcardlink === '1'"
          >
            <i class="el-icon-wallet" />
            <span>{{ $t("grxx.cardmanagement") }}</span>
          </div>
        </div>
        <!-- 右侧内容 -->
        <div class="cards">
          <!-- 基本资料 -->
          <div
            class="card overf-y-a"
            v-if="activeMenu == '1'"
            :style="jbxxStyle"
          >
            <div class="jbxx">
              <p>{{ $t("grxx.basicinformation") }}</p>
              <div class="pt-20">
                <el-form
                  ref="jbxx"
                  key="jbxx"
                  :model="userInfo"
                  label-width="120px"
                  label-position="left"
                  size="small"
                >
                  <el-form-item :label="$t('grxx.headportrait')">
                    <img :src="userImg" class="head pl-16" />
                  </el-form-item>
                  <el-form-item :label="$t('grxx.username')">
                    <span class="pl-16">{{ userInfo.yhmc }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('grxx.department')">
                    <span class="pl-16">{{ userInfo.bmmc }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('grxx.role')">
                    <span class="pl-16">{{ userInfo.userJs }}</span>
                  </el-form-item>
                  <!-- <el-form-item label="用户状态">
                    <el-switch
                      v-model="userInfo.islocked"
                      @change="xgjb()"
                    ></el-switch>
                  </el-form-item>
                  <el-form-item label="本地用户">
                    <el-switch
                      v-model="userInfo.bdyh"
                      @change="xgjb()"
                    ></el-switch>
                  </el-form-item> -->
                </el-form>
              </div>
            </div>
            <div class="grxx">
              <p>{{ $t("grxx.personalinformation") }}</p>
              <div class="pt-20">
                <el-form
                  ref="grxx"
                  key="grxx"
                  :model="personalInfo"
                  label-width="120px"
                  label-position="left"
                  size="small"
                  :rules="lxfsRules"
                >
                  <!-- <el-form-item label="证件号">
                    <p class="wt-300">
                      <el-input
                        v-model="personalInfo.zjh"
                        @input="xggr()"
                        disabled
                      ></el-input>
                    </p>
                  </el-form-item> -->
                  <el-form-item :label="$t('grxx.phonenumber')" prop="lxdh">
                    <p class="wt-300">
                      <el-input
                        v-model="personalInfo.lxdh"
                        @input="xggr()"
                      ></el-input>
                    </p>
                  </el-form-item>
                  <el-form-item :label="$t('grxx.email')" prop="email">
                    <p class="wt-300">
                      <el-input
                        v-model="personalInfo.email"
                        @input="xggr()"
                      ></el-input>
                    </p>
                  </el-form-item>
                  <el-form-item
                    :label="$t('grxx.verification')"
                    prop="yzm"
                    v-if="$store.state.sysCs.sfqysendmsg === '1'"
                  >
                    <p class="wt-300">
                      <el-input
                        v-model="personalInfo.yzm"
                        class="wt-p-45"
                        :placeholder="$t('grxx.verificationcode')"
                      ></el-input>
                      <el-button
                        class="ml-10"
                        type="primary"
                        size="small"
                        @click="hqyzm(personalInfo.lxdh)"
                        v-if="acquire"
                      >
                        <span>{{ $t("grxx.verification") }}</span></el-button
                      >
                      <el-button
                        class="ml-10"
                        type="primary"
                        size="small"
                        plain
                        disabled
                        v-else
                      >
                        <span>{{
                          "(" + second + ")" + $t("grxx.restartafter")
                        }}</span>
                      </el-button>
                    </p>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <el-button
              type="primary"
              size="small"
              class="mt-24 ml-16"
              @click="
                lxfsCommit(
                  personalInfo.lxdh,
                  personalInfo.email,
                  personalInfo.yzm
                )
              "
              >{{ $t("common.saveBtn") }}
            </el-button>
          </div>
          <!-- 修改密码 -->
          <div
            class="card overf-y-a"
            v-else-if="
              activeMenu == '2' && $store.state.sysCs.sfqyeditpwdlink === '1'
            "
            :style="xgmmStyle"
          >
            <div class="xgmm">
              <p class="color-b fs-16">{{ $t("grxx.changepassword") }}</p>
              <p class="fs-14 color-r mt-10">
                {{ $t("grxx.passtip") }}
              </p>
              <div class="pt-20">
                <el-form
                  ref="xgmm"
                  key="xgmm"
                  :model="xgmm"
                  label-width="130px"
                  label-position="left"
                  size="small"
                  :rules="rules"
                >
                  <el-form-item :label="$t('grxx.oldpass')" prop="oldmm">
                    <p class="wt-300">
                      <el-input
                        v-model="xgmm.oldmm"
                        type="password"
                        :placeholder="$t('grxx.Enteroldpass')"
                        show-password
                      ></el-input>
                    </p>
                  </el-form-item>
                  <el-form-item :label="$t('grxx.newpass')" prop="newmm">
                    <p class="wt-300">
                      <el-input
                        v-model="xgmm.newmm"
                        type="password"
                        :placeholder="$t('grxx.Enternewpass')"
                        show-password
                      ></el-input>
                    </p>
                  </el-form-item>
                  <el-form-item :label="$t('grxx.confirmpass')" prop="qrmm">
                    <p class="wt-300">
                      <el-input
                        v-model="xgmm.qrmm"
                        type="password"
                        :placeholder="$t('grxx.Enternewpassagain')"
                        show-password
                      ></el-input>
                    </p>
                  </el-form-item>
                  <el-form-item
                    :label="$t('grxx.verificationcode')"
                    prop="yzm"
                    v-if="$store.state.sysCs.sfqysendmsg === '1'"
                  >
                    <p class="wt-300">
                      <el-input
                        v-model="xgmm.yzm"
                        class="wt-p-45"
                        :placeholder="$t('grxx.verificationcode')"
                      ></el-input>
                      <el-button
                        class="ml-10"
                        type="primary"
                        size="small"
                        @click="hqyzm2(personalInfo.lxdh)"
                        v-if="acquire2"
                      >
                        <span>{{ $t("grxx.verification") }}</span></el-button
                      >
                      <el-button
                        class="ml-10"
                        type="primary"
                        size="small"
                        plain
                        disabled
                        v-else
                      >
                        <span>{{
                          "(" + second2 + ")" + $t("grxx.restartafter")
                        }}</span>
                      </el-button>
                    </p>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <el-button
              type="primary"
              size="small"
              class="mt-24 ml-16"
              @click="updateUpw()"
              >{{ $t("common.saveBtn") }}</el-button
            >
          </div>
          <!-- 银行卡管理 -->
          <div
            class="card overf-y-a"
            v-else-if="
              activeMenu == '3' && $store.state.sysCs.sfqy_editcardlink === '1'
            "
          >
            <p>{{ $t("grxx.bankmanagement") }}</p>
            <el-row class="pt-20 ml-20 mr-10 overf-a" :style="yhkglStyle">
              <!-- 工资卡 -->
              <el-row class="my-20" v-if="gzzh.sfqy_editcard_yhk == '1'">
                <el-row>
                  <p class="fs-18 color-b fw-7">
                    {{ !gzzh.cardName ? "工资卡" : gzzh.cardName }}：
                  </p>
                  <el-row type="flex" class="mt-5 align-i-c">
                    <img
                      src="/img/images/fonts/warning2.png"
                      style="height:16px"
                    />
                    <span class="ml-5 color-g"
                      >{{ gzzh.sm_editcard_yhk }}
                    </span>
                  </el-row>
                </el-row>
                <el-row class="mt-10">
                  <el-col :span="11">
                    <el-input
                      v-model="gzzh.cardNum"
                      :disabled="true"
                      v-if="gzzh.cardeye"
                    >
                      <template #prepend
                        ><span class="color-b">{{
                          $t("grxx.Originalaccount")
                        }}</span></template
                      >
                      <template #append>
                        <i
                          class="fa fa-eye"
                          @click="gzzh.cardeye = !gzzh.cardeye"
                        />
                      </template>
                    </el-input>
                    <el-input v-model="gzzh.cardNumEye" :disabled="true" v-else>
                      <template #prepend
                        ><span class="color-b">{{
                          $t("grxx.Originalaccount")
                        }}</span></template
                      >
                      <template #append>
                        <i
                          class="fa fa-eye-slash"
                          @click="gzzh.cardeye = !gzzh.cardeye"
                        />
                      </template>
                    </el-input>
                  </el-col>
                  <el-col :span="11">
                    <el-input v-model="gzzh.newNum">
                      <template #prepend
                        ><span class="color-b">{{
                          $t("grxx.newaccount")
                        }}</span></template
                      >
                    </el-input>
                  </el-col>
                  <el-col :span="2">
                    <el-button type="primary" @click="xgyhzhCommit(gzzh)">{{
                      $t("grxx.submit")
                    }}</el-button>
                  </el-col>
                </el-row>
              </el-row>
              <!-- 普通卡 -->
              <template v-for="(item, index) in yhzhs">
                <el-row
                  :key="index"
                  class="my-20"
                  v-if="item.sfqy_editcard_yhk == '1'"
                >
                  <el-row>
                    <p class="fs-18 color-b fw-7">{{ item.cardName }}：</p>
                    <el-row type="flex" class="mt-5 align-i-c">
                      <img
                        src="/img/images/fonts/warning2.png"
                        style="height:16px"
                      />
                      <span class="ml-5 color-g"
                        >{{ item.sm_editcard_yhk }}
                      </span>
                    </el-row>
                  </el-row>
                  <el-row class="mt-10">
                    <el-col :span="11">
                      <el-input
                        v-model="item.cardNum"
                        :disabled="true"
                        v-if="item.cardeye"
                      >
                        <template #prepend
                          ><span class="color-b">{{
                            $t("grxx.Originalaccount")
                          }}</span></template
                        >
                        <template #append>
                          <i
                            class="fa fa-eye"
                            @click="item.cardeye = !item.cardeye"
                          />
                        </template>
                      </el-input>
                      <el-input
                        v-model="item.cardNumEye"
                        :disabled="true"
                        v-else
                      >
                        <template #prepend
                          ><span class="color-b">{{
                            $t("grxx.Originalaccount")
                          }}</span></template
                        >
                        <template #append>
                          <i
                            class="fa fa-eye-slash"
                            @click="item.cardeye = !item.cardeye"
                          />
                        </template>
                      </el-input>
                    </el-col>
                    <el-col :span="11">
                      <el-input v-model="item.khhmc" :disabled="true">
                        <template #prepend
                          ><span class="color-b">{{
                            $t("grxx.Originalbank")
                          }}</span></template
                        >
                      </el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-button
                        type="danger"
                        @click="delCard(item)"
                        style="margin-left:0px"
                        >{{ $t("grxx.delete") }}</el-button
                      >
                    </el-col>
                  </el-row>
                  <el-row class="mt-15">
                    <el-col :span="11">
                      <el-input v-model="item.newNum">
                        <template #prepend
                          ><span class="color-b">{{
                            $t("grxx.newaccount")
                          }}</span></template
                        >
                      </el-input>
                    </el-col>
                    <el-col :span="11">
                      <el-input v-model="item.newYh" @focus="cxlhh(item.index)">
                        <template #prepend>
                          <span class="color-b">{{ $t("grxx.newbank") }}</span>
                        </template>
                      </el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-button type="primary" @click="xgyhzhCommit(item)">{{
                        $t("grxx.submit")
                      }}</el-button>
                    </el-col>
                  </el-row>
                </el-row>
              </template>
              <!-- 公务卡 -->
              <el-row class="my-20" v-if="gwkh.sfqy_editcard_yhk == '1'">
                <el-row>
                  <p class="fs-18 color-b fw-7">公务卡：</p>
                  <el-row type="flex" class="mt-5 align-i-c">
                    <img
                      src="/img/images/fonts/warning2.png"
                      style="height:16px"
                    />
                    <span class="ml-5 color-g"
                      >{{ gwkh.sm_editcard_yhk }}
                    </span>
                  </el-row>
                </el-row>
                <el-row class="mt-10">
                  <el-col :span="11">
                    <el-input
                      v-model="gwkh.cardNum"
                      :disabled="true"
                      v-if="gwkh.cardeye"
                    >
                      <template #prepend
                        ><span class="color-b">{{
                          $t("grxx.Originalaccount")
                        }}</span></template
                      >
                      <template #append>
                        <i
                          class="fa fa-eye"
                          @click="gwkh.cardeye = !gwkh.cardeye"
                        />
                      </template>
                    </el-input>
                    <el-input v-model="gwkh.cardNumEye" :disabled="true" v-else>
                      <template #prepend
                        ><span class="color-b">{{
                          $t("grxx.Originalaccount")
                        }}</span></template
                      >
                      <template #append>
                        <i
                          class="fa fa-eye-slash"
                          @click="gwkh.cardeye = !gwkh.cardeye"
                        />
                      </template>
                    </el-input>
                  </el-col>
                  <el-col :span="11">
                    <el-input v-model="gwkh.newNum">
                      <template #prepend
                        ><span class="color-b">{{
                          $t("grxx.newaccount")
                        }}</span></template
                      >
                    </el-input>
                  </el-col>
                  <el-col :span="2">
                    <el-button type="primary" @click="xgyhzhCommit(gwkh)">{{
                      $t("grxx.submit")
                    }}</el-button>
                  </el-col>
                </el-row>
              </el-row>
            </el-row>
            <!-- 查询开户行 -->
            <el-dialog
              width="50%"
              :title="$t('grxx.Inquirybank')"
              :visible.sync="dialogcxlhh"
              append-to-body
            >
              <el-row type="flex" justify="center">
                <el-col :span="10">
                  <el-input
                    v-model="lhhstring"
                    :placeholder="$t('grxx.khhtip')"
                  ></el-input>
                </el-col>
                <el-col :span="4" class="ml-20">
                  <el-button type="primary" plain @click="getLhh()">{{
                    $t("common.searchBtn")
                  }}</el-button>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                justify="center"
                class="color-danger text-a-c"
              >
                <el-col :span="24" class="mt-10">
                  {{ "*" + $t("grxx.khhtip") }}
                </el-col>
                <!-- <el-col :span="4"> </el-col> -->
              </el-row>
              <el-row class="mt-20">
                <el-row>
                  <!-- 动态表格组件 -->
                  <TableCommon
                    v-loading="tabLoading"
                    :element-loading-text="$t('elTable.loadingText')"
                    element-loading-spinner="el-icon-loading"
                    :tableColumns="tableColumns"
                    :tableData="lhhList"
                    :currentPage="currentPage"
                    :limit="limit"
                    :uniqueNum="uniqueNum"
                    @rowclick="rowclick"
                    :height="450"
                  ></TableCommon>
                </el-row>
                <el-row>
                  <!-- 分页组件 -->
                  <Pagination
                    :currentPage="currentPage"
                    :total="total"
                    :limit="limit"
                    :small="true"
                    :pageSizes="$store.state.pageSizes"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                    :uniqueNum="uniqueNum"
                  />
                </el-row>
              </el-row>
            </el-dialog>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import Languageqh from "@/components/Languageqh.vue";
export default {
  // 个人中心
  name: "personalCenter",
  components: {
    Languageqh,
  },
  computed: {
    // 用户头像
    userImg() {
      this.userInfo.photo = this.$store.state.yhxx.phtot;
      return this.$store.state.yhxx.phtot;
    },
    yhkglStyle() {
      return {
        height: this.$store.state.screenHeight - 220 + "px",
      };
    },
    xgmmStyle() {
      return {
        "max-height": "380px",
        height: this.$store.state.screenHeight - 200 + "px",
      };
    },
    jbxxStyle() {
      return {
        "max-height": "600px",
        height: this.$store.state.screenHeight - 200 + "px",
      };
    },
  },
  data() {
    const validateOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("common.qsrjmm")));
      } else {
        let publicKey = this.$store.state.pubKey;
        let key = this.$rsa(publicKey);
        key.setOptions({
          encryptionScheme: "pkcs1",
        });
        let playload = key.encrypt(value, "base64", "utf8");
        let user = {};
        user.yhbh = this.userInfo.yhbh;
        user.upw = playload;
        yhxx.pwdCheck(user).then((res) => {
          if (res.data.code == 200) {
            if (res.data.data == "0") {
              callback(new Error(this.$t("common.jmmyzsbcs")));
            } else {
              this.oldmmok = true;
              callback();
            }
          } else {
            callback(new Error(this.$t("common.jmmyzsbcs")));
          }
        });
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("common.qsrxmm")));
      } else {
        if (
          !this.$store.state.sysCs.passwordVerify ||
          this.$store.state.sysCs.passwordVerify === "0"
        ) {
          if (value.length < 6) {
            callback(new Error(this.$t("common.mmzs6w")));
          } else if (this.$store.state.sysCs.sfqyweekpwdchk == "1") {
            let publicKey = this.$store.state.pubKey;
            let key = this.$rsa(publicKey);
            key.setOptions({
              encryptionScheme: "pkcs1",
            });
            let playload = key.encrypt(value, "base64", "utf8");
            let user = {};
            user.upw = playload;
            yhxx.weekPwdChk(user).then((res2) => {
              if (res2.data.code == 200) {
                console.log(res2.data.message, res2.data.data < 50);
                if (res2.data.data < 50) {
                  callback(new Error(this.$t("common.mmrcxsr")));
                } else {
                  callback();
                }
              }
            });
          } else {
            callback();
          }
        } else {
          let ze = new RegExp(this.$store.state.sysCs.passwordVerify);
          if (ze.test(value)) {
            if (this.xgmm.qrmm !== "") {
              this.$refs.xgmm.validateField("checkPass");
              callback();
            }
          } else {
            callback(new Error(this.$store.state.sysCs.passwordVerifyHint));
          }
        }
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("common.qzcsrxmm")));
      } else if (value !== this.xgmm.newmm) {
        callback(new Error(this.$t("common.lcmmbyy")));
      } else {
        callback();
      }
    };
    const validateLxdh = (rule, value, callback) => {
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则
      if (!reg_tel.test(value)) {
        callback(new Error("请输入正确格式"));
      } else {
        callback();
      }
    };
    const validateEmail = (rule, value, callback) => {
      let reg_mal = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (value === "") {
        callback();
      } else if (!reg_mal.test(value)) {
        callback(new Error("请输入正确格式"));
      } else {
        callback();
      }
    };
    return {
      activeMenu: "1",
      uniqueNum: "Y118101-1-1", // 页面唯一标识（用于区分同一页面多个模块多个分组情况）
      second: 60, // 获取验证码时倒计时
      acquire: true, // 控制获取验证码按钮是否可点击
      second2: 60, // 获取验证码时倒计时
      acquire2: true, // 控制获取验证码按钮是否可点击
      gzzh: { index: 0 }, // 工资卡号
      dialogcxlhh: false, // 控制查询开户行弹出框
      lhhstring: null, // 开户行名称
      tabLoading: false, // 控制查询开户行刷新显示
      currentPage: 1, // 当前页
      limit: this.$store.state.dataDisplayNum, // 每页数据量
      tableColumns: [], // 表格表头
      cardInfo: {}, // 银行卡信息
      activeInput: -2, // 记录点击的是第几个银行卡
      total: 0, // 数据量
      cards: [], // 银行卡数据
      yhzhs: [], // 银行账户
      gwkh: { index: 6 }, // 公务卡号
      lhhList: [], // 开户行集合
      lhh: [], // 选择的开户行
      userInfo: {},
      personalInfo: {},
      xgmm: {
        oldmm: "",
        newmm: "",
        qrmm: "",
        yzm: "",
      },
      rules: {
        oldmm: [
          { required: true, validator: validateOldPass, trigger: "blur" },
        ],
        yzm: [
          {
            required: true,
            message: this.$t("common.qsryzm"),
            trigger: "blur",
          },
        ],
        newmm: [{ required: true, validator: validatePass, trigger: "blur" }],
        qrmm: [{ required: true, validator: validatePass2, trigger: "blur" }],
      },
      lxfsRules: {
        lxdh: [{ required: true, validator: validateLxdh, trigger: "blur" }],
        email: [{ required: false, validator: validateEmail, trigger: "blur" }],
      },
      xggrxx: false,
      oldmmok: false,
      yzmlxdh: "",
      conmit: true,
      gzkeye: false,
      gwkeye: false,
    };
  },
  methods: {
    selectMenu(acMenu) {
      this.xgmm = {
        oldmm: "",
        newmm: "",
        qrmm: "",
        yzm: "",
      };
      if (this.activeMenu == 1) {
        let mes = "";
        let xg = 0;
        if (this.xggrxx) {
          this.$confirm(this.$t("common.grxxgdsfbc"), this.$t("common.tips"), {
            confirmButtonText: this.$t("common.confirmBtn"),
            cancelButtonText: this.$t("common.cancelBtn"),
            type: "warning",
          })
            .then(() => {
              this.lxfsCommit(
                this.personalInfo.lxdh,
                this.personalInfo.email,
                this.personalInfo.yzm
              );
            })
            .catch(() => {
              this.setUser();
              this.xggrxx = false;
            });
        } else {
          this.activeMenu = acMenu;
        }
      } else {
        this.activeMenu = acMenu;
      }
    },
    setUser() {
      this.userInfo = {};
      this.personalInfo = {};
      let users = this.$store.state.userInfo;
      let yhxx = JSON.parse(JSON.stringify(this.$store.state.yhxx.yhxx));
      this.userInfo = JSON.parse(JSON.stringify(users[0]));
      this.personalInfo = JSON.parse(JSON.stringify(yhxx));
      this.userInfo.userJs = "";
      users.forEach((item) => {
        this.userInfo.userJs = this.userInfo.userJs + item.jsname + " ";
      });
      this.userInfo.bmmc = yhxx.gzbmmc;
      this.userInfo.yhmc = yhxx.ygmc;
      this.userInfo.roleid = yhxx.roleId;
      this.personalInfo.zjh = this.userInfo.zjh;
    },
    // 获取用户信息
    getyhxx() {
      yhxx.getYhxx().then((res1) => {
        this.$store.commit("yhxx/setYhxx", res1.data.data);
      });
    },
    // 更新用户
    updateUser() {
      yhxx.updateUser(this.userInfo).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: this.$t("common.bccg"),
            type: "success",
          });
          this.$requestUtil
            .getUserInfo({ suid: this.userInfo.suid })
            .then((tmpResult) => {
              // _this.$store.dispatch('setUserInfo', tmpResult);
              this.$store.commit("setUserInfo", tmpResult);
              this.setUser();
            });
        } else if (res.data.code === 500) {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    // 修改联系方式提交
    lxfsCommit(mobie, email, yzm) {
      this.$refs["grxx"].validate((valid) => {
        if (valid) {
          if (this.yzmlxdh == "" || this.yzmlxdh == mobie) {
            if (
              (yzm && yzm !== "") ||
              this.$store.state.sysCs.sfqysendmsg != "1"
            ) {
              let param = {};
              param.mobie = mobie;
              param.email = email;
              param.yzm = yzm;
              yhxx.updateLxfs(param).then((res) => {
                if (res.data.code === 200) {
                  this.personalInfo.yzm = "";
                  this.second = 0;
                  yhxx.getYhxx().then((res1) => {
                    this.$store.commit("yhxx/setYhxx", res1.data.data);
                    this.setUser();
                  });
                  this.$message({
                    message: res.data.message,
                    type: "success",
                  });
                  this.xggrxx = false;
                } else if (res.data.code === 500) {
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
              this.dialogxglxfs = false;
            } else {
              this.$confirm(
                "<span class='fs-16 fw-600'>" +
                  this.$t("common.qxsryzm") +
                  "</span>",
                this.$t("common.tips"),
                {
                  confirmButtonText: this.$t("common.confirmBtn"),
                  type: "warning",
                  center: true,
                  showCancelButton: false,
                  dangerouslyUseHTMLString: true,
                }
              );
            }
          } else {
            this.$message.error(this.$t("common.sjhbyzcxhq"));
          }
        }
      });
    },
    // 修改个人信息
    xggr() {
      this.xggrxx = true;
    },
    // 修改联系方式获取验证码
    hqyzm(mobie) {
      this.$refs["grxx"].validate((valid) => {
        if (valid) {
          if (mobie && mobie != "") {
            let regular = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
            if (!regular.test(mobie)) {
              this.$message.error(this.$t("common.qsrzqsjh"));
            } else {
              this.second = 60;
              this.acquire = false;
              yhxx.sendMessage({ mobie: mobie, type: "xglxfs" }).then((res) => {
                if (res.data.code === 200) {
                  this.yzmlxdh = mobie;
                  this.$message({
                    message: res.data.data,
                    type: "success",
                  });
                } else {
                  this.$message({
                    message: res.data.message,
                    type: "error",
                  });
                }
              });
              let con = setInterval(() => {
                this.second = this.second - 1;
                if (this.second <= 0) {
                  this.acquire = true;
                  clearInterval(con);
                }
              }, 1000); //延迟1000毫秒
            }
          } else {
            this.$message({
              message: this.$t("common.sjhwkqsr"),
              type: "error",
            });
          }
        }
      });
    },
    // 修改密码获取验证码
    hqyzm2(mobie) {
      if (mobie && mobie != "") {
        if (this.oldmmok) {
          if (this.xgmm.newmm != "" && this.xgmm.newmm == this.xgmm.qrmm) {
            this.second2 = 60;
            this.acquire2 = false;
            yhxx.sendMessage({ mobie: mobie, type: "xgmm" }).then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: res.data.data,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.message,
                  type: "error",
                });
              }
            });
            let con = setInterval(() => {
              this.second2 = this.second2 - 1;
              if (this.second2 <= 0) {
                this.acquire2 = true;
                clearInterval(con);
              }
            }, 1000); //延迟1000毫秒
          } else {
            this.$message({
              type: "error",
              message: this.$t("common.xmmkbyy"),
            });
          }
        } else {
          this.$message({
            type: "error",
            message: this.$t("common.jmmcw"),
          });
        }
      } else {
        this.$message({
          message: this.$t("common.szsjhhqyzm"),
          type: "error",
        });
      }
    },
    // 修改密码
    updateUpw() {
      this.$refs["xgmm"].validate((valid) => {
        if (valid) {
          if (
            (this.xgmm.yzm && this.xgmm.yzm != "") ||
            this.$store.state.sysCs.sfqysendmsg != "1"
          ) {
            let publicKey = this.$store.state.pubKey;
            let key = this.$rsa(publicKey);
            key.setOptions({
              encryptionScheme: "pkcs1",
            });
            let playload = key.encrypt(this.xgmm.qrmm, "base64", "utf8");
            let user = {};
            user.yhbh = this.userInfo.yhbh;
            user.upw = playload;
            user.yzm = this.xgmm.yzm;
            yhxx.updateyhmm(user).then((res) => {
              if (res.data.code == 200) {
                if (
                  this.$store.state.sysCs.sfqy_dycqzxgmm == "1" &&
                  sessionStorage.getItem("isupdatemm")
                ) {
                  sessionStorage.removeItem("isupdatemm");
                }
                this.$message({
                  type: "success",
                  message: this.$t("common.pwdSuccess"),
                });
              }
            });
          } else {
            this.$confirm(
              "<span class='fs-16 fw-600'>" +
                this.$t("common.qxsryzm") +
                "</span>",
              this.$t("common.tips"),
              {
                confirmButtonText: this.$t("common.confirmBtn"),
                type: "warning",
                center: true,
                showCancelButton: false,
                dangerouslyUseHTMLString: true,
              }
            );
          }
        } else {
          return false;
        }
      });
    },
    // 修改银行账户提交
    xgyhzhCommit(item) {
      let commit = true;
      let index = item.index;
      let pattern = /^([1-9]{1})(\d{12,18})$/;
      if (!item.newNum) {
        commit = false;
        this.$message.error(this.$t("common.qtxxzh"));
      } else if (!pattern.test(item.newNum)) {
        commit = false;
        this.$message.error(this.$t("common.qsrzqyhkh"));
      } else if (
        this.$store.state.sysCs.khhbt &&
        this.$store.state.sysCs.khhbt != "0" &&
        index != 6 &&
        index != 0
      ) {
        if (item.newYh == null || item.newYh == "") {
          commit = false;
          this.$message.error(this.$t("common.khhbtqtx"));
        }
      }
      if (commit) {
        let yhmc;
        if (index < 6) {
          yhmc = item.newYh.substring(2, 6);
        }
        const param = {
          ygmc: this.userInfo.yhmc,
          roleId: this.userInfo.roleid,
          oldyhzh: item.cardNum,
        };
        switch (index) {
          case 0:
            param.yhzh = item.newNum;
            // param.Khhmc = item.newYh;
            // param.lhh = item.newYhCode;
            // param.yhmc = yhmc;
            // param.yh = "ABC";
            break;
          case 1:
            param.yhzh1 = item.newNum;
            param.Khhmc1 = item.newYh;
            param.lhh1 = item.newYhCode;
            // param.yhmc1 = yhmc;
            param.yhmc1 = item.cardName;
            break;
          case 2:
            param.yhzh2 = item.newNum;
            param.Khhmc2 = item.newYh;
            param.lhh2 = item.newYhCode;
            // param.yhmc2 = yhmc;
            param.yhmc2 = item.cardName;
            break;
          case 3:
            param.yhzh3 = item.newNum;
            param.Khhmc3 = item.newYh;
            param.lhh3 = item.newYhCode;
            // param.yhmc3 = yhmc;
            param.yhmc3 = item.cardName;
            break;
          case 4:
            param.yhzh4 = item.newNum;
            param.Khhmc4 = item.newYh;
            param.lhh4 = item.newYhCode;
            // param.yhmc4 = yhmc;
            param.yhmc4 = item.cardName;
            break;
          case 5:
            param.yhzh5 = item.newNum;
            param.Khhmc5 = item.newYh;
            param.lhh5 = item.newYhCode;
            // param.yhmc5 = yhmc;
            param.yhmc5 = item.cardName;
            break;
          case 6:
            param.gwkh = item.newNum;
            break;
        }
        let cardName;
        if (this.$store.state.sysCs.yhzhVerify == "1") {
          cardName = item.cardName;
        } else {
          cardName = "";
        }
        // if (
        //   this.$store.state.sysCs.yhzhVerify == "1" &&
        //   index != 6 &&
        //   index != 0
        // ) {
        let yhkh = item.newNum.substring(0, 6);

        if (this.$store.state.sysCs.sfqy_cardbinyz == "0") {
          this.updataYhzh(param);
        } else {
          yhxx.yhzhVerify({ yhmc: cardName, yhkh: yhkh }).then((res) => {
            if (res.data.data) {
              this.updataYhzh(param);
            } else {
              this.$confirm(
                "<span class='fs-16 fw-600'>" + res.data.message + "</span>",
                this.$t("common.tips"),
                {
                  confirmButtonText: this.$t("common.confirmBtn"),
                  type: "warning",
                  center: true,
                  showCancelButton: false,
                  dangerouslyUseHTMLString: true,
                }
              );
            }
          });
        }
      }
    },
    updataYhzh(param) {
      yhxx.updataYhzh(param).then((res) => {
        this.getyhxx();
        this.getYhzhInfo();
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    /** 打开查询开户行弹窗 */
    cxlhh(index) {
      this.activeInput = index;
      this.dialogcxlhh = true;
    },
    /** 根据关键字获取开户行 */
    getLhh() {
      let s = [];
      let params = {};
      if (this.lhhstring != null && this.lhhstring != "") {
        s = this.lhhstring.split(" ");
      }
      params.yhName = s;
      params.currentPage = this.currentPage;
      params.limit = this.limit;
      yhxx.getLhhList(params).then((res) => {
        this.lhhList = res.data.data;
        this.total = this.lhhList[0].count;
      });
    },
    // 修改银行卡信息
    setYhCard(yhxx, i) {
      const cards = [];
      const card = {
        newNum: "",
        newYh: "",
        newYhCode: "",
        cardName: yhxx.yhmc == "" ? "工资卡" : yhxx.yhmc,
        cardNum: yhxx.yhzh,
        khhmc: yhxx.khhmc,
        yh: yhxx.yh,
        sfqy_editcard_yhk: this.$store.state.sysCs.sfqy_editcard_gzk,
        sm_editcard_yhk: this.$store.state.sysCs.sm_editcard_gzk,
        index: 0,
        cardeye: false,
        cardNumEye: this.cardEncryption(yhxx.yhzh),
      };
      if (i == 0) {
        cards.push(card);
      } else {
        this.gzzh = card;
      }
      const card6 = {
        cardName: "公务卡",
        cardNum: yhxx.gwkh,
        sfqy_editcard_yhk: this.$store.state.sysCs.sfqy_editcard_gwk,
        sm_editcard_yhk: this.$store.state.sysCs.sm_editcard_gwk,
        index: 6,
        cardeye: false,
        cardNumEye: this.cardEncryption(yhxx.gwkh),
      };
      if (i == 0) {
        cards.push(card6);
      } else {
        this.gwkh = card6;
      }
      if (yhxx.yhzh1 && yhxx.yhzh1 != "") {
        const card1 = {
          newNum: "",
          newYh: "",
          newYhCode: "",
          cardName: yhxx.yhmc1 == "" ? "银行卡1" : yhxx.yhmc1,
          cardNum: yhxx.yhzh1,
          khhmc: yhxx.khhmc1,
          yh: yhxx.yh1,
          sfqy_editcard_yhk: this.$store.state.sysCs.sfqy_editcard_yhk1,
          sm_editcard_yhk: this.$store.state.sysCs.sm_editcard_yhk1,
          index: 1,
          cardeye: false,
          cardNumEye: this.cardEncryption(yhxx.yhzh1),
        };
        cards.push(card1);
      }
      if (yhxx.yhzh2 && yhxx.yhzh2 != "") {
        const card2 = {
          newNum: "",
          newYh: "",
          newYhCode: "",
          cardName: yhxx.yhmc2 == "" ? "银行卡2" : yhxx.yhmc2,
          cardNum: yhxx.yhzh2,
          khhmc: yhxx.khhmc2,
          yh: yhxx.yh2,
          sfqy_editcard_yhk: this.$store.state.sysCs.sfqy_editcard_yhk2,
          sm_editcard_yhk: this.$store.state.sysCs.sm_editcard_yhk2,
          index: 2,
          cardeye: false,
          cardNumEye: this.cardEncryption(yhxx.yhzh2),
        };
        cards.push(card2);
      }
      if (yhxx.yhmc3 && yhxx.yhzh3 != "") {
        const card3 = {
          newNum: "",
          newYh: "",
          newYhCode: "",
          cardName: yhxx.yhmc3 == "" ? "银行卡3" : yhxx.yhmc3,
          cardNum: yhxx.yhzh3,
          khhmc: yhxx.khhmc3,
          yh: yhxx.yh3,
          sfqy_editcard_yhk: this.$store.state.sysCs.sfqy_editcard_yhk3,
          sm_editcard_yhk: this.$store.state.sysCs.sm_editcard_yhk3,
          index: 3,
          cardeye: false,
          cardNumEye: this.cardEncryption(yhxx.yhzh3),
        };
        cards.push(card3);
      }
      if (yhxx.yhmc4 && yhxx.yhzh4 != "") {
        const card4 = {
          newNum: "",
          newYh: "",
          newYhCode: "",
          cardName: yhxx.yhmc4 == "" ? "银行卡4" : yhxx.yhmc4,
          cardNum: yhxx.yhzh4,
          khhmc: yhxx.khhmc4,
          yh: yhxx.yh4,
          sfqy_editcard_yhk: this.$store.state.sysCs.sfqy_editcard_yhk4,
          sm_editcard_yhk: this.$store.state.sysCs.sm_editcard_yhk4,
          index: 4,
          cardeye: false,
          cardNumEye: this.cardEncryption(yhxx.yhzh4),
        };
        cards.push(card4);
      }
      if (yhxx.yhmc5 && yhxx.yhzh5 != "") {
        const card5 = {
          newNum: "",
          newYh: "",
          newYhCode: "",
          cardName: yhxx.yhmc5 == "" ? "银行卡5" : yhxx.yhmc5,
          cardNum: yhxx.yhzh5,
          khhmc: yhxx.khhmc5,
          yh: yhxx.yh5,
          sfqy_editcard_yhk: this.$store.state.sysCs.sfqy_editcard_yhk5,
          sm_editcard_yhk: this.$store.state.sysCs.sm_editcard_yhk5,
          index: 5,
          cardeye: false,
          cardNumEye: this.cardEncryption(yhxx.yhzh5),
        };
        cards.push(card5);
      }
      return cards;
    },
    // 表格点击行事件
    rowclick(row, column, event) {
      if (this.activeInput == 0) {
        this.gzzh.newYh = row.yhName;
        this.gzzh.newYhCode = row.yhCode;
      } else if (this.activeInput == 6) {
        this.gwkh.newYh = row.yhName;
        this.gwkh.newYhCode = row.yhCode;
      } else {
        this.yhzhs.map((item) => {
          if (item.index == this.activeInput) {
            item.newYh = row.yhName;
            item.newYhCode = row.yhCode;
          }
        });
      }
      this.dialogcxlhh = false;
    },
    /** 获取页面表格配置信息 */
    getPageTableConfig() {
      let params = {};
      params.pageId = "Y116101";
      params.moduleId = "1";
      params.groupId = "1";
      // 清空表格列配置
      this.tableColumns = []; // 表格列
      // 异步回调
      this.$requestUtil.getXtTableConfig(params).then((tmpResult) => {
        this.tableColumns = tmpResult;
      });
    },
    /** 获取银行配置信息 */
    getYhzhInfo() {
      // 获取银行卡基本信息
      yhxx.getYhzhInfo().then((res) => {
        if (res.data.code == 200) {
          this.yhzhs = this.setYhCard(res.data.data, 1);
        }
      });
    },
    /** 删除银行卡 */
    delCard(item) {
      yhxx.delCard({ yhzhNum: item.index }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: this.$t("common.scyhkcg"),
            type: "success",
          });
        } else {
          this.$message({
            message: this.$t("common.scyhksb"),
            type: "error",
          });
        }
        this.getyhxx();
        this.getYhzhInfo();
      });
    },
    /** 页码改变时会触发 */
    handleCurrentChange(uniqueNum, val) {
      this.currentPage = val;
      this.getLhh();
    },
    /** 每页条数改变时触发 */
    handleSizeChange(uniqueNum, val) {
      this.limit = val;
      this.getLhh();
    },
    /** 银行卡号加密 */
    cardEncryption(cardnum) {
      let befor = cardnum.substring(0, 4);
      let after = cardnum.substring(cardnum.length - 4, cardnum.length);
      let newnum = befor + " **** **** " + after;
      return newnum;
    },
  },
  mounted() {
    this.setUser();
    this.getPageTableConfig();
    // 获取银行配置信息
    this.getYhzhInfo();
    if (this.$route.params.activeMenu) {
      this.activeMenu = this.$route.params.activeMenu;
    }
  },
};
</script>

<style lang="scss" scoped>
.menu {
  height: 42px;
  background-color: white;
  padding-left: 20px;
  cursor: pointer;
  i {
    line-height: 42px;
    font-size: 16px;
  }
  span {
    line-height: 42px;
    padding-left: 20px;
    font-size: 14px;
  }
}
.menu:hover {
  color: #0d6ce4;
  background-color: #e7f1fc;
}
.acMenu {
  color: #0d6ce4;
  border-right: solid 2px #0d6ce4;
  background-color: #e7f1fc;
}
.cards {
  width: 80%;
  margin-top: 20px;
  margin-left: 20px;
  height: fit-content;
  background-color: white;
  .card {
    padding: 25px 15px 25px 20px;
  }
}
.jbxx {
  border-bottom: solid 1px #eeeeee;
  div {
    padding-left: 16px;
    p {
      color: #666666;
      font-size: 14px;
    }
  }
}
.xgmm {
  border-bottom: solid 1px #eeeeee;
}
.head {
  width: 60px;
  height: 60px;
}
.grxx {
  margin-top: 20px;
  border-bottom: solid 1px #eeeeee;
  .el-form {
    padding-left: 36px;
    p {
      color: #666666;
      font-size: 14px;
    }
  }
}
.jy-content-c {
  justify-content: center;
}
</style>
